import { render, staticRenderFns } from "./BrokerSelector.vue?vue&type=template&id=a8d849ac&"
import script from "./BrokerSelector.vue?vue&type=script&lang=js&"
export * from "./BrokerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports